import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { translate } from '../../services';
import { translate,service ,sessionStore} from '../../services';
import { IconButton, ExportCartPanel, ImportCartPanel, ProductPrice, ExportToWholeSalerCart, 
  ExportToExternal, ExportToPartnerHub,PopupMessage, RemoveButton } from '..';
import { CloseIconNew, DeleteIconNew, ExportIconNew, ImportIconNew, TrashWhiteIconNew, downloadIcon, forwardArrowIcon, starIcon, uploadIcon , cartAddIcon} from '../../../style/images';
import { PropTypes } from 'prop-types';
import { popupDispatcher, cartState, siteSettingsState, identityState, productState, priceState, 
  currentNodeState, combineStates, cartDispatcher, messageDispatcher, 
  apttusDispatcher, combineDispatchers } from '../../store';
import { PricingModule, getTransformedProducts, preProcessProducts, getCartItems, UserIdentity, getUserAssignments } from '../../util';
import { ExportToApttus } from '../ExportToApttus';
import { CbolCartInfo } from '.';
import { PopupType } from '..';
import { RemoveProductsCart } from './RemoveProductsCart';
import { Box, Dialog, Drawer } from '@mui/material';
import { IconButton as MuiIconButton } from '@material-ui/core';

// const co= "nl" 
// const l= "en" 


export class CartFooterComponent extends Component {
  constructor( props ){
    super( props );
    this.state = {
      isExporting : false,
      showDeleteAllPopUp: false,
      showExport: false,
      showImport: false,
      toggle: false,
      showCbolCartInfo: false,
      // link: this.openEcart
    }
  }

  
  openImport = () => {
    this.setState({showImport:true})
    this.onToggle();
    // this.props.setPopup( { title: 'Import Cart', component: <ImportCartPanel />, showHeader: true, keepOpen: false } );
  }
  
  openCbolCartInfo = () =>{
    this.setState({showCbolCartInfo:true})
    this.onToggle();
  }
  openEcart =()=>{
    console.log("cart2",this.props.items)
    //reading paramters stored
    const YourParam=sessionStore.get("BuyNowUTM")
    let arr=[]
    let obj={}
    let group='';
    let utm_source= "econfigure" 
    let params=''
    let lite=[]
    const timestamp = Date.now();
    group = "econfigure" + " "+ new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(timestamp)
    if(YourParam){
      //splitting the parameters string
    arr=YourParam.split('&');
    //creating key-value pair
    obj=arr.reduce((acc,a)=>{ acc[a.split('=')[0]]=a.split('=')[1]; return acc},{});
   // checking if these properties are part of URL, then use those
    if(obj.hasOwnProperty('group')){
      group=obj['group']
      delete obj['group'];
    }
    if(obj.hasOwnProperty('utm_source')){
      utm_source=obj['utm_source']
      delete obj['utm_source']
    }
  
    if(obj.hasOwnProperty('lite')){
      lite=obj['lite']
      delete obj['lite']
    }    
    if(Object.keys(obj).length>0){
      Object.keys(obj).forEach(o=> {params+=o+'='+obj[o]+'&'})
    } }
    
    let codes = [];
    let url = '';
    const ecartURL=this.props?.siteSettings?.properties?.ecartURL;
    const co=this.props?.siteSettings?.properties?.co;
    const l=this.props?.siteSettings?.properties?.l;
    
    if(this.props && this.props.items ){
      this.props.items?.forEach((item)=>{
          let obj={
            pn:item.code,
            qty:item.amount
          }
          codes.push(obj)
    if(item && item.importAccessories){
          item.importAccessories?.forEach((acc)=>{
            let obj2={
              pn:acc.accessoryCode,
              qty:item.amount
            }
            codes.push(obj2)
          })
        }
    if(item && item.configuration && item.configuration.bomComponents){
          item.configuration.bomComponents?.forEach((bom)=>{
            let obj3={
              pn:bom.component,
              qty:item.amount
            }
            codes.push(obj3)
          })
    }
    })
    if(codes && codes.length>0){
    codes.forEach((ob)=>{
      url+='pn[]='+ob.pn+'&qty[]='+ob.qty+'&'
    })
  }
  // this.setState( { link:  `https://dev.tnbmobile.ca/ecart/?co=${co}&l=${l}&utm_source=${utm_source}&group=${group}&${url}`} )
  let ecartPL=`${ecartURL}?co=${co}&l=${l}&utm_source=${utm_source}`
  if(params.length>0){
    ecartPL+=`&group=${group}${params}${url}&lite=${lite}`
  }
  else{
    ecartPL+=`&group=${group}${url}&lite=${lite}`
  }
  //check for country while calling URL
  if(co==='pl'){ 
    window.open(ecartPL)
  }
  else{
  window.open(`${ecartURL}?co=${co}&l=${l}&utm_source=${utm_source}&group=${group}&${url}&lite=${lite}`)}
    }
  }
  openExport = () => {
    console.group(this.props.items,"Exportpopup")
    // this.props.setPopup( { title: 'Export Cart', component: <ExportCartPanel cartItems={ getCartItems(this.props.items)} />, showHeader: true, keepOpen: false } );
    this.setState({showExport:true})
    this.onToggle();
  }
  closeExport = ()=>{
    this.setState({showExport:false})
    this.onToggle();
  }
  closeImport = ()=>{
    this.setState({showImport:false})
    this.onToggle();
  }

  closeCbolCartInfo = ()=>{
    this.setState({showCbolCartInfo:false})
    this.onToggle();
  }
  async prepareProducts( products ) {
    var bom = [];
    products.forEach( product => product.bomItems?.reduce( ( bom, item ) =>{ bom.push( item.value.name ); return bom;}, bom ) );
    return this.props.getProducts( bom ).then( () => preProcessProducts( products ) );
  }
  deleteFromCart = items => {
    for(const item of items ){
      this.props.deleteFromCart( item );
    }
  }
  showWarningForWrongConfiguration(items){
    let assignmentsWithNullKey=[];
    let missedManditoryFields =[];
    let flag=false;
    for(let m=0;m<items.length;m++){
      if(items[m].configuration!=undefined){
        if(items[m].configuration.assignments.length != 0){
          const assignments = items[m].configuration.assignments.map( assignment => {
            if(assignment.Key){
              assignment.key = assignment.Key;
            }
            return assignment;
          });
          assignmentsWithNullKey= assignments.filter( assignment => assignment.key == null);
          if( assignmentsWithNullKey.any(item => Object.keys(this.props.products).indexOf(item.value) === -1 ) ){
            flag= true;
          }
          let assignmetsMap=new Map();
          // Getting the User Assignments from the configuration and comparing to see if all the mandatory 
          // selection are made from the existing assignments
          const userAssignments = getUserAssignments( items[m].configuration );
          userAssignments.forEach(element => {
            assignmetsMap.set(element.key,element.value);
          });
          items[m]["configuration"].model.children[0].variables.forEach(variable => {
            if(variable.properties.Required && variable.fullyQualifiedName.indexOf('Selector.') < 0 && variable.properties.IsBomItem){
              if(!(assignmetsMap.has(variable.fullyQualifiedName) || items[m].configuration.bomComponents && items[m].configuration.bomComponents.any(bom => bom.component === variable.textValue))){
                missedManditoryFields.push(variable.fullyQualifiedName);
              }
            }
          });
          if(missedManditoryFields.length>0){
            flag = true;
            break;
          }else if(flag && missedManditoryFields.length === 0){
            flag = false;
          }
        }
      }
    }
    return flag;
  }

  sendToCbol = () => {
    const {  user, items, currentNode, products } = this.props;
    this.mounted && this.setState( { isAdding: true } );
    const cartItems = Array.isArray(items) ? items : [items];

    const tempTransformedProducts = getTransformedProducts(cartItems, products, user.authenticationType, 
      currentNode, this.context.properties, false, null, null);
    let transformedProducts = [];
    tempTransformedProducts.forEach(item => {
      if(item.isSuperConfiguration){
        item.additionalProducts.forEach(prod => {
          transformedProducts.push(prod);
        })
      }else{
        transformedProducts.push(item);
      }
    });

    return service( 'formatdocument' ).post( transformedProducts, UserIdentity.token ).then( result => {
      document.cbolForm.action = user.properties.HookUrl;
      document.cbolForm.ConfigResponse.value = result.data;
      document.cbolForm.submit();   
      this.mounted && this.setState( { isAdding: false } );
      this.props.addMessage( {  timeout: 5000, messageText: translate( 'products sent to Cbol cart' ), messageType: 'confirmation'  } )
      this.deleteFromCart(cartItems);
    } ).catch( this.handleMessageResponse ); 
  }
  getStatus = value => {
    this.setState( { isExporting : value } );
  }

  getCartItemsForPH = (items)=>{
    return items.map(item=>item.isSuperConfiguration?item.additionalProducts[0]:item);
  }

  exportToPartnerHub = () => {
    const { items , user } = this.props;
    const isPMPortalCall = user.authenticationType === 'PartnerHub' && user.properties.source === 'pmportal';
    this.props.setPopup( { 
      title: isPMPortalCall ? translate( 'Export to PM Portal' ) : translate( 'Export to PartnerHub' ), 
      component: <ExportToPartnerHub cartItems={ this.getCartItemsForPH(items) } getExportStatus = { this.getStatus } />, 
      showHeader: true, 
      keepOpen: true } );
  }

  exportToExternal = () => {
    const { items , user } = this.props;
    this.props.setPopup( { 
      title: translate( 'Export to QFA' ), 
      component: <ExportToExternal cartItems={ getCartItems(items)  } getExportStatus = { this.getStatus } />, 
      showHeader: true, 
      keepOpen: true } );
  }
  bolAction = () => {
    const { items, prices, user } = this.props;
    this.props.setPopup(
      {
        title: `${ translate( 'Saving To BOL' ) }`,
        component: <ExportToApttus cart={ items } prices={ prices } user={ user } reConfig={false}/>,
        showHeader: true,
        keepOpen: true
      } );
  }
  apttusAction = () => {
    const { items, prices, user } = this.props;
    this.props.setPopup(
      {
        title: `${ translate( 'Saving To Apttus' ) }`,
        component: <ExportToApttus cart={ items } prices={ prices } user={ user } reConfig={false}/>,
        showHeader: true,
        keepOpen: true
      } );
  }

  addToFav = () => {

  }

  exportToWholeSalerCart = () => {
    this.props.setPopup( { 
      title: translate( 'Export to external cart' ), 
      component: <ExportToWholeSalerCart cartItems={ getCartItems(this.props.items) } getExportStatus = { this.getStatus } />, 
      showHeader: true, 
      keepOpen: true } );
  }
  deleteAllItems=()=>{
    const { items }= this.props;
    let count=0;
    let delete_all=true;
    items.forEach(item=>{count+=item.amount;
      this.props.deleteFromCart( item , delete_all)});
    let productcount=count>1?'products':'product'
    let messageText=count+' '+translate(productcount) +' '+translate('removed from cart')
    this.props.addMessage({  timeout: 10000, messageText:messageText , messageType: 'confirmation'  })
    this.closeRemoveDialog()  
    //this.setState({showDeleteAllPopUp: false})
  }
  deleteAll=()=>{
    const {items} = this.props;
    console.log("delete all");
    this.setState({showDeleteAllPopUp: true})
    // this.props.setPopup({
    //   title: `Warning`,
    //   // component: <PopupMessage
    //   //   text={ translate( 'Do you really want to remove items from the cart?' ) } 
    //   //   actionText={ translate( 'Remove' ) }
    //   //   cancelText={ translate( 'Dismiss' ) }
    //   //   onClick={this.deleteAllItems}
    //   //   popupType={ PopupType.Warning }
        
    //   // />,
    //   component:<RemoveProductsCart onClick={this.deleteAllItems}></RemoveProductsCart>,
    //   showHeader: false,
    //   keepOpen: false,
    //   className:"popup-remove"
    // });

  }

  closeRemoveDialog=()=>{
    this.setState({showDeleteAllPopUp: false})
  }

  onToggle=()=>{
    if(this.state.toggle){
      this.state.showExport&&this.setState({showExport:false})
      this.state.showImport&&this.setState({showImport:false})
      this.state.showCbolCartInfo&&this.setState({showCbolCartInfo:false})
    }
    this.setState({toggle:!this.state.toggle})
  }
  render() {
    const { items, siteSettings, user } = this.props;
    console.log(items);
    const showEcart = siteSettings.properties?.showEcart;
    const isQFACall = user.authenticationType === 'QFA';
    const isPHCall = user.authenticationType === 'PartnerHub';
    const isPMPortalCall = user.authenticationType === 'PartnerHub' && user.properties.source === 'pmportal';
    const isCbolCall = user.authenticationType === 'Cbol';
    const isWSCall = user.authenticationType === 'WS';
    const isApttus = user.authenticationType === 'Apttus';
    const isBol = user.properties.CallingApp === 'BOL';
    const hideExportButton = this.showWarningForWrongConfiguration( getCartItems( items ) );
    const phExportButtonText = isPMPortalCall ? translate( 'Send To PM Portal' )  : translate( 'Send To PartnerHub' );
    const YourParam=sessionStore.get("BuyNowUTM");
    let showEcartParam=false; 
    //creating key-value pair
    let obj=YourParam && YourParam.split('&')?.reduce((acc,a)=>{ acc[a?.split('=')[0]]=a?.split('=')[1]; return acc},{});
    if(obj  && obj.hasOwnProperty('showEcart')){
      showEcartParam=obj['showEcart']=="true"?true:false;
    }
    else{
      showEcartParam=showEcart;
    }
    return<>{this.props.mobileCartFooter?<>
       { items.length!==0 && <IconButton className="white-round-button" icon={TrashWhiteIconNew} disabled={items.length===0} onClick={ this.deleteAll } /> }
        { !isCbolCall && <IconButton className="white-round-button" icon={ ImportIconNew } onClick={ this.openImport } /> }
        { !hideExportButton && !isCbolCall && <IconButton className="white-round-button" icon={ ExportIconNew } disabled={items.length===0} onClick={ this.openExport } /> }
        {/* { <IconButton className="red-round-button" icon={ cartAddIcon } text={ translate( "Order options" ) } onClick={ this.openImport } /> } */}
        { siteSettings.showExternalLinks &&<IconButton className="primary-button" icon={ cartAddIcon } text={ translate( "Order options" ) } onClick={ this.openCbolCartInfo } /> }
    </>: 
    <div className="cart-footer">
      {/* <div className="price-panel">
        { PricingModule.showPrice( siteSettings.pricingModule ) && <span>{ translate( 'Total' ) }</span> }
        { PricingModule.showPrice( siteSettings.pricingModule ) && <ProductPrice fromCart priceSize='big' products={ getCartItems(items) } /> }
      </div> */}
      <div className="cart-action-panel">
        { false && <IconButton icon={ starIcon } text={ translate( 'Add to favourites' ) } onClick={ this.addToFav } /> }
        {/* { <IconButton className="blue-button" text={ translate( 'Delete All' ) } onClick={ this.deleteAll } /> } */}
        {items.length!==0 && <IconButton className="white-round-button" icon={DeleteIconNew} text={ translate( 'Delete All' ) } disabled={items.length===0} onClick={ this.deleteAll } /> }
        { !isCbolCall && <IconButton className="white-round-button" icon={ ImportIconNew } text={ translate( "Import Cart" ) } onClick={ this.openImport } /> }
        { !hideExportButton && !isCbolCall && <IconButton className="white-round-button" icon={ ExportIconNew } text={ translate( 'Export cart' ) } disabled={items.length===0} onClick={ this.openExport } /> }
        {/* { showEcart && <IconButton className="blue-button" onClick={this.openEcart} text={'Add to eCart'}/>} */}
        { showEcartParam && <IconButton className="primary-button" onClick={this.openEcart} text={'Buy now'}/>}
        {/* { !isCbolCall && showEcart && <a className="ecart" href={this.state.link} target='_blank' onClick={this.openEcart}>Ecart</a> } */}
        { !hideExportButton && isQFACall && <IconButton disabled={ this.state.isExporting } className="primary-button" icon={ forwardArrowIcon } text={ translate( 'Send To Apttus' ) } onClick={ this.exportToExternal } /> }
        { !hideExportButton && isPHCall && <IconButton disabled={ this.state.isExporting } className="primary-button" icon={ forwardArrowIcon } text={ phExportButtonText } onClick={ this.exportToPartnerHub } />}
        { !hideExportButton && isApttus && !isBol && <IconButton className="primary-button" text={ translate( 'Save To Apttus' ) } onClick={ this.apttusAction } /> }
        { !hideExportButton && isBol && <IconButton className="primary-button" text={ translate( 'Save To BOL' ) } onClick={ this.bolAction } /> }
        { !hideExportButton && isCbolCall && <IconButton className="primary-button" icon={ forwardArrowIcon } text={ translate( 'Add To Cart' ) } onClick={ this.sendToCbol } /> }
        { !hideExportButton && isWSCall && <IconButton className="primary-button" text={ translate( 'Send to Wholesaler cart' ) } onClick={ this.exportToWholeSalerCart } disabled = { this.state.isExporting }/>}
        {siteSettings.showExternalLinks && <IconButton className="primary-button" icon={ cartAddIcon } text={ translate( "Order options" ) } onClick={ this.openCbolCartInfo } /> }
      </div>
      {/* {siteSettings.showExternalLinks && <CbolCartInfo/>} */}
    </div>}
    <Dialog open={this.state.showDeleteAllPopUp} onClose={this.closeRemoveDialog} PaperProps={{sx:{position:"absolute", top:{md:"auto", xs:"296px"}}}}>
        <RemoveProductsCart onClose={this.closeRemoveDialog} onDelete={this.deleteAllItems}/> 
      </Dialog>
    {
      !this.props.mobileCartFooter?<>
      <Dialog open={this.state.showExport} onClose={this.closeExport} PaperProps={{sx:{position:"absolute", top:"auto"}}}>
        <ExportCartPanel cartItems={ getCartItems(this.props.items)} onClose={this.closeExport}/> 
      </Dialog>
      <Dialog open={this.state.showImport} onClose={this.closeImport} PaperProps={{sx:{position:"absolute", top:"auto"}}}>
        <ImportCartPanel onClose={this.closeImport}/> 
      </Dialog>
      {siteSettings.showExternalLinks && <Dialog open={this.state.showCbolCartInfo} onClose={this.closeCbolCartInfo} PaperProps={{sx:{maxWidth:"812px", position:"absolute", top:"auto"}}}>
           <CbolCartInfo onClose={this.closeCbolCartInfo}/>
      </Dialog>}
      
      </>:<>
      {this.state.showExport &&
      <Drawer
      anchor="bottom"
      open={this.state.toggle}
      onClose={this.onToggle}
      BackdropProps={{sx:{background:"rgba(0, 0, 0, 0.1)"}}}
      PaperProps={{
        sx: {
          boxShadow:"none",
          borderRadius: "12px 12px 0px 0px",
          background: "var(--brand-primary-white, #FFF)"
        }
      }}
      >
      <ExportCartPanel cartItems={ getCartItems(this.props.items)} onClose={this.closeExport}/></Drawer>
      }
      {
        this.state.showImport&&
        <Drawer
          anchor="bottom"
          open={this.state.toggle}
          onClose={this.onToggle}
          BackdropProps={{sx:{background:"rgba(0, 0, 0, 0.1)"}}}
          PaperProps={{
            sx: {
              boxShadow:"none",
              borderRadius: "12px 12px 0px 0px",
              background: "var(--brand-primary-white, #FFF)"
            }
          }}
          >
       
          <ImportCartPanel onClose={this.closeImport} mobileCartFooter={true}/>
        </Drawer>}
        {
        this.state.showCbolCartInfo&&
        <Drawer
          anchor="bottom"
          open={this.state.toggle}
          onClose={this.onToggle}
          BackdropProps={{sx:{background:"rgba(0, 0, 0, 0.1)"}}}
          PaperProps={{
            sx: {
              boxShadow:"none",
              borderRadius: "12px 12px 0px 0px",
              background: "var(--brand-primary-white, #FFF)"
            }
          }}
          >
       
            <CbolCartInfo onClose={this.closeCbolCartInfo}/>
        </Drawer>}
      </>
    }
    </>;
  }
}

CartFooterComponent.propTypes = {
  items: PropTypes.arrayOf( PropTypes.shape( {} ) ),
  setPopup: PropTypes.func.isRequired,
  siteSettings: PropTypes.shape( {
    pricingModule: PropTypes.number.isRequired
  } )
};

export const CartFooter = connect( combineStates( cartState, siteSettingsState, priceState, identityState, productState, currentNodeState ),
combineDispatchers( apttusDispatcher, cartDispatcher, messageDispatcher , popupDispatcher ) )( CartFooterComponent );
